export function upperCaseStringFirstChar(str) {
  return str?.length > 0 && str[0].toUpperCase() + str.substr(1);
}
